import { render } from "./TemplateSlugModal.vue?vue&type=template&id=ae01f492&ts=true"
import script from "./TemplateSlugModal.vue?vue&type=script&lang=ts"
export * from "./TemplateSlugModal.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1570380721/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__